import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SetLoyaltyPointsComponent } from './set-loyalty-points.component';
import { IonicModule } from '@ionic/angular';
import { ReactiveFormsModule } from '@angular/forms';
import { DesignUtilitiesModule } from 'src/app/appModules/design-utilities.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [SetLoyaltyPointsComponent],
  imports: [
    IonicModule,
    CommonModule,
    TranslateModule,
    ReactiveFormsModule,
    DesignUtilitiesModule,
  ],
  exports: [SetLoyaltyPointsComponent, TranslateModule],
})
export class SetLoyaltyPointsModule {}
